module.exports = __webpack_public_path__ + "media/images/icons/address-655d1155a0d809e0e5b8445a7f05b7cd.svg";